/**
 * 배송 라벨 인쇄 (SHIPPING_PLAN.md §6).
 *
 * base64 → Blob → 숨은 iframe 에 띄우고 인쇄 대화상자를 연다. 팝업 차단과 무관하다.
 * PDF 는 브라우저 내장 뷰어가 그리므로 Zebra 드라이버든 일반 프린터든 그대로 나간다.
 * ZPL(text/plain)은 브라우저가 못 찍는다 — 내려받기만 한다.
 */
export const printLabel = (params: {
	base64: string
	mime: string
	fileName?: string
}) => {
	const { base64, mime } = params
	const fileName = params.fileName ?? 'label'
	if (!base64) return

	const bytes = Uint8Array.from(atob(base64), c => c.charCodeAt(0))
	const blob = new Blob([bytes], { type: mime || 'application/pdf' })
	const url = URL.createObjectURL(blob)

	if (!mime.includes('pdf')) {
		downloadLabel({ url, fileName: `${fileName}.zpl` })
		return
	}

	const prev = document.getElementById('labelPrintFrame')
	if (prev) prev.remove()

	const iframe = document.createElement('iframe')
	iframe.id = 'labelPrintFrame'
	iframe.style.position = 'fixed'
	iframe.style.right = '0'
	iframe.style.bottom = '0'
	iframe.style.width = '0'
	iframe.style.height = '0'
	iframe.style.border = '0'
	iframe.src = url
	iframe.onload = () => {
		try {
			iframe.contentWindow?.focus()
			iframe.contentWindow?.print()
		} catch {
			// 인쇄를 못 열면 새 탭으로라도
			window.open(url, '_blank', 'noopener')
		}
		// 인쇄 대화상자가 닫힌 뒤 정리
		setTimeout(() => {
			URL.revokeObjectURL(url)
		}, 60 * 1000)
	}
	document.body.appendChild(iframe)
}

const downloadLabel = (params: { url: string; fileName: string }) => {
	const a = document.createElement('a')
	a.href = params.url
	a.download = params.fileName
	document.body.appendChild(a)
	a.click()
	a.remove()
	setTimeout(() => URL.revokeObjectURL(params.url), 10 * 1000)
}
